import React, { Component } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

import Header from "../Components/Header";
import Button from "../Components/Button";
import CodeValueInput from "../Components/CodeValueInput";
import { API_URL } from '../Config';
import { parseHash } from '../Url';
import { handleErrors } from '../Helpers'

const CODE_LENGTH = 6;

const Code = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin: 1rem 0;

  div:nth-child(3) {
    display: flex;
    align-items: center;
    
    :after {
      display: inline-block;
      margin: 0 .5rem;
      content: "–";
    }
  }
`;

const AddPlayerButton = styled.button`
  text-transform: uppercase;
  width: 13rem;
  font-size: 16px;
  margin-bottom: 1rem;
  color: #ccc;
  border-radius: 2rem;
  padding: .6rem 0;
  border-color: currentColor;
  transition: all .25s ease-in-out;
  ${({ disabled }) => !disabled && `
    background-color: #0019F8;
    color: #fff;
    border-color: #0019F8;
  `}
`

const Container = styled.div`
  text-align: center;
  width: 22rem;
  margin: 0 auto;
`

export default class AddPlayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      codeVal0: "",
      codeVal1: "",
      codeVal2: "",
      codeVal3: "",
      codeVal4: "",
      codeVal5: "",
      validated: false,
      locations: window.persistence.local.get("locations") || {}
    };
  }

  componentDidMount() {
    this.codeInput0.input.focus();
    let params = parseHash()
    if (params.code && params.code.length === 6) {
      this.setState({
        codeVal0: params.code[0],
        codeVal1: params.code[1],
        codeVal2: params.code[2],
        codeVal3: params.code[3],
        codeVal4: params.code[4],
        codeVal5: params.code[5]
      }, () => {
        this.onCodeSubmit({ preventDefault: () => { } })
      })
    }
    // window.persistence.local.remove("locations");
  }

  validateCode(nextState) {
    return (
      nextState.codeVal0 &&
      nextState.codeVal1 &&
      nextState.codeVal2 &&
      nextState.codeVal3 &&
      nextState.codeVal4 &&
      nextState.codeVal5
    );
  }

  handleCodeInputOnChange(el, index) {
    const value = el.target.value;
    this.setState({
      [`codeVal${index}`]: value
    });

    if (value !== "" && this[`codeInput${index + 1}`]) {
      this[`codeInput${index + 1}`].input.focus();
    } else if (this.state.validated) {
      console.log("end and validated");
      // focus add player button?
    }
  }

  componentWillUpdate(props, nextState) {
    // check code validation
    if (!this.state.validated && this.validateCode(nextState)) {
      this.setState({ validated: true });
    } else if (this.state.validated && !this.validateCode(nextState)) {
      this.setState({ validated: false });
    }
  }

  onCodeSubmit(e) {
    e.preventDefault();
    const code = `${this.state.codeVal0}${this.state.codeVal1}${
      this.state.codeVal2
      }${this.state.codeVal3}${this.state.codeVal4}${this.state.codeVal5}`;
    fetch(`${API_URL}/authenticate`, {
      method: "POST",
      body: JSON.stringify({
        remoteCode: code.toUpperCase()
      })
    })
      .then(handleErrors)
      .then(response => response.json())
      .then(response => {
        const locations = window.persistence.local.get("locations") || {};
        if (
          Object.keys(locations).some(location => {
            return locations[location].zones.some(
              zone => zone.remoteCode === response.remoteCode
            );
          })
        ) {
          alert("Player already added");
        } else {
          const zone = {
            token: response.token,
            name: response.name,
            remoteCode: response.remoteCode,
            location: response.location
          };
          if (!locations[response.location.name]) {
            locations[response.location.name] = {};
            locations[response.location.name].zones = [];
          }
          locations[response.location.name].zones.push(zone);
          window.persistence.local.set("locations", locations);
          window.persistence.local.set("currentZone", zone);
          this.props.setCurrentZone(zone);
          this.props.history.push("/player");
        }
      })
      .catch(error => {
        alert(`Could not add player. You probably used an invalid Remote code. Please try again`);
        this.setState({
          codeVal0: "",
          codeVal1: "",
          codeVal2: "",
          codeVal3: "",
          codeVal4: "",
          codeVal5: ""
        });
        this.codeInput0.input.focus();
      })
  }

  renderCodeInput = () => {
    let code = [];

    for (let i = 0; i < CODE_LENGTH; i++) {
      code.push(
        <CodeValueInput
          key={`codeInput-${i}`}
          ref={el => (this[`codeInput${i}`] = el)}
          value={this.state[`codeVal${i}`]}
          onChange={el => {
            this.handleCodeInputOnChange(el, i);
          }}
        />
      );
    }
    return code;
  };

  render() {
    return (
      <div>
        <Header
          title="Add Player"
          rightComponent={
            this.state.locations && Object.keys(this.state.locations).length > 0 && <Button label="Cancel" style={{ fontSize: '16px', padding: '1rem' }} onClick={() => this.props.history.goBack()} />
          }
        />
        <Container>
          <p>Enter your remote code to<br />add a player</p>
          <form
            style={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap"
            }}
            action="add"
            onSubmit={e => this.onCodeSubmit(e)}
          >
            {/* $fix - onChange should check if value is of letter or number...if not don't display the value, check if all values are filled, set add player button state */}
            <Code>{this.renderCodeInput()}</Code>
            <div style={{ width: "100%" }}>
              <AddPlayerButton type="submit" disabled={!this.state.validated}>
                Add Player
              </AddPlayerButton>
            </div>
          </form>
          <p style={{ fontSize: '14px', marginBottom: '3rem' }}>
            Login in to Soundtrack Business and go to the zone page to find your
            remote code.
          </p>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <a href="https://help.soundtrackbusiness.com/" target="_blank" className="bold" style={{ fontSize: '14px', color: '#999', padding: '1rem' }}>Need Help?</a>
          </div>
        </Container>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Views/AddPlayer.js